import { context } from '@wikia/ad-engine';

export function getOpenXContext(): object {
	const floorAdhesionConfig = context.get('experiments.persistentAdhesionExperiment')
		? {
				adhesion_limited: {
					unit: '561021744',
				},
			}
		: {
				floor_adhesion: {
					unit: '561045365',
				},
			};

	return {
		enabled: false,
		delDomain: 'wikia-d.openx.net',
		slots: {
			featured: {
				unit: '559098631',
			},
			...floorAdhesionConfig,
		},
	};
}
